/** @format */

import { Box, Text } from "@chakra-ui/react";
import { Slider } from "../Slider";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { usePersonalizacao } from "../../context/usePersonalizacao";
import { useHistory } from "react-router-dom";

const SlickArrow = ({ currentSlide, slideCount, children, ...restNext }) => (
  <Box {...restNext}>{children}</Box>
);

export function BoxList({
  title,
  children,
  isVisibleVermais = true,
  bgcolorTitle,
  textcolorTitle,
  isFeed = false,
  ...props
}) {
  const {
    personalizacao: { guiaofertas },
  } = usePersonalizacao();
  const history = useHistory();

  const settings = {
    arrows: true,
    slidesToShow: 4.2,
    infinite: false,
    lazyLoad: "ondemand",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: true,
          slidesToShow: 3.7,
        },
      },
      {
        breakpoint: 800,
        settings: {
          arrows: true,
          slidesToShow: 3.2,
        },
      },
      {
        breakpoint: 690,
        settings: {
          arrows: false,
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: false,
          slidesToShow: 1.7,
        },
      },
    ],
    nextArrow: (
      <SlickArrow>
        <FaChevronRight
          aria-label="next offer"
          color={guiaofertas.colortextvermais}
          size={30}
        />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <FaChevronLeft
          aria-label="previous offer"
          color={guiaofertas.colortextvermais}
          size={30}
        />
      </SlickArrow>
    ),
  };

  return (
    <Box mt="0.5rem" mb="2rem" height="auto">
      <Box
        display="flex"
        flexDir="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="1rem"
      >
        {!isFeed && (
          <Box
            background={bgcolorTitle}
            borderTopRightRadius="full"
            borderBottomRightRadius="full"
          >
            <Text
              marginX="1rem"
              fontSize="lg"
              color={textcolorTitle}
              fontWeight="bold"
            >
              {title}
            </Text>
          </Box>
        )}
        <Box
          display="flex"
          flexDir="row"
          alignItems="center"
          {...props}
          cursor="pointer"
        >
          {isVisibleVermais && !isFeed && (
            <>
              <Text
                fontSize="sm"
                color={guiaofertas.colortextvermais}
                marginRight="0.5rem"
                fontWeight="semibold"
              >
                Ver mais
              </Text>
              <FaChevronRight
                color={guiaofertas.colortextvermais}
                size={12}
                style={{ marginTop: 0 }}
              />
            </>
          )}
        </Box>
      </Box>
      {history.location.pathname === "/carrosselpreview" ? (
        <Box px="4" pb="2" w="100%" h="375px" className="recomendacaoCardSlide" display="flex" flexDirection="row" overflowX="scroll" overflowY="hidden" whiteSpace="nowrap" alignItems="center">
          {children}
        </Box>
      ) : (
        <Box w="100%" className="recomendacaoCardSlide">
          <Slider settings={settings}>{children}</Slider>
        </Box>
      )}
    </Box>
  );
}
